import { useEffect, useState } from "react";
import axios from "axios";
import { Alert, Fab, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { Progress } from "..";

const renderResponse = (res) => {
  if (res.error) {
    return <Alert severity="error">{res.error}</Alert>;
  }

  return (
    <div>
      <Typography variant="h4">
        <Fab aria-label="save" color="success">
          <CheckIcon />
        </Fab>
        &nbsp; &nbsp; Submitting {res.subscriptions} un-subscriptions. You will
        receive two emails. One confirming when all been sent to the queue, and
        one when when they have been actioned.
      </Typography>
    </div>
  );
};

export const SubmitRemovals = ({ selectedFile, setNextStepDisabled }) => {
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState(null);

  useEffect(() => {
    if (!selectedFile) {
      setLoading(false);
      setResponse({ error: "Please select a file" });
      return;
    }

    const formData = new FormData();
    formData.append("upload", selectedFile, selectedFile.name);

    setLoading(true);
    axios
      .post(`${process.env.REACT_APP_BACKEND_API}/submitRemovals`, formData)
      .then((response) => response.data)
      .then((data) => {
        setResponse(data);
        setNextStepDisabled(false);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setResponse({ error: error.message });
      });
  }, [selectedFile, setNextStepDisabled]);

  if (loading) return <Progress text="Submitting removals..." />;

  return response ? renderResponse(response) : "";
};
